import {Component, h} from 'preact'
import {FilterSelectorComponent } from './interfaces'
import SearchBox from "../../search-box/SearchBox";
import Fetch from "../../selector/Fetch";
import Icon from "../../assets";
import FilterOption from "./FilterOption";

type State = {
  data: any,
  fetchedItems: any[],
  value: string
}

class DynamicFilterSelector extends Component<FilterSelectorComponent, State> {
  constructor (props: FilterSelectorComponent) {
    super(props)
    this.state = {
      data: this.props.selectedFilterItems,
      fetchedItems: [],
      value: ''
    }
  }

  onFilterOptionSelection = (payload: string[]) => {
    const { fetchedItems } = this.state
    const data = payload.map(item => fetchedItems.filter(x => String(x.id) === String(item))[0])
    this.setState({ data })
  }

  normalizeFetchedItems = (items: any[]) => items.map(item => ({
    id: item.id,
    name: item.name,
    avatar: item.avatar,
    value: item.id
  }))

  render({ id, name, children, fetchUrl, onLoad } : FilterSelectorComponent, { data, value, fetchedItems } : State) {
    return <div>
    <div className='overview__filters-box-content'>
      <SearchBox
          isModerationOverview
          placeholder={`Search for ${name}`}
          value={value}
          onSubmit={() => {}}
          onInput={(e) => this.setState({value: (e.target as HTMLInputElement).value})}
          onClear={() => this.setState({ value: '' })}
      />
      <Fetch baseUrl={fetchUrl || ''} searchValue={value} onLoaded={(items: any[]) => {
        if(onLoad) {
          const normalizedItems = this.normalizeFetchedItems(items)
          this.setState(({ fetchedItems }) => {
            const allItems = [...data, ...normalizedItems]
                .filter((item, index, self) => index === self.findIndex(x => x.id === item.id))

            return { fetchedItems: allItems }
          })
          onLoad(id, normalizedItems)
        }
      }} >
        {({ loading, items } : { loading: boolean, items: any[] }) => {
          if(loading) return <div class='loader'><Icon icon='loader' /></div>
          return <div>{ this.normalizeFetchedItems(fetchedItems)
                .map(item =>
                    <FilterOption
                        item={item}
                        data={data.map((y: { value: any }) => String(y.value))}
                        onFilterOptionSelection={this.onFilterOptionSelection}
                    />)
            }</div>
        }
        }
      </Fetch>
    </div>
      {children[0]({
        data,
        isApplyButtonDisabled: data.length === 0
      })}
    </div>
  }
}

export default DynamicFilterSelector
